import { pgEnum } from 'drizzle-orm/pg-core';
import * as z from 'zod';
export const StabilityStage = z.enum([
    'UNOPENED',
    'AFTER_OPENING',
    'AFTER_RECONSTITUTION',
    'AFTER_PREPARATION',
]);
export const stabilityStageEnum = pgEnum('stability_stage', [
    StabilityStage.enum.UNOPENED,
    StabilityStage.enum.AFTER_OPENING,
    StabilityStage.enum.AFTER_RECONSTITUTION,
    StabilityStage.enum.AFTER_PREPARATION,
]);
export const DurationUnit = z.enum(['MINUTES', 'HOURS', 'DAYS']);
export const durationUnitEnum = pgEnum('duration_unit', [
    DurationUnit.enum.MINUTES,
    DurationUnit.enum.HOURS,
    DurationUnit.enum.DAYS,
]);
export const ExpiryRuleType = z.enum(['HARD_EXPIRY', 'RECOMMENDED', 'UNKNOWN']);
export const expiryRuleTypeEnum = pgEnum('expiry_rule_type', [
    ExpiryRuleType.enum.HARD_EXPIRY,
    ExpiryRuleType.enum.RECOMMENDED,
    ExpiryRuleType.enum.UNKNOWN,
]);
export const MicrobiologicalLimitation = z.enum(['USE_IMMEDIATELY', 'USE_WITHIN_LIMIT', 'NOT_SPECIFIED']);
export const microbiologicalLimitationEnum = pgEnum('microbiological_limitation', [
    MicrobiologicalLimitation.enum.USE_IMMEDIATELY,
    MicrobiologicalLimitation.enum.USE_WITHIN_LIMIT,
    MicrobiologicalLimitation.enum.NOT_SPECIFIED,
]);
/**
 * Tells us what resource the stability rule was created for. Useful to prevent updating a medication profile's stability rule when updated a trade name.
 */
export const StabilityRuleSource = z.enum(['MEDICATION_PROFILE', 'TRADE_NAME']);
export const stabilityRuleSourceEnum = pgEnum('stability_rule_source_enum', [
    StabilityRuleSource.enum.MEDICATION_PROFILE,
    StabilityRuleSource.enum.TRADE_NAME,
]);
export const VolumeMode = z.enum(['IN', 'AD']);
export const volumeModeEnum = pgEnum('volume_mode', [VolumeMode.enum.IN, VolumeMode.enum.AD]);
export const FormType = z.enum([
    'TABLET',
    'CAPSULE',
    'POWDER',
    'CONCENTRATE',
    'SOLUTION_READY',
    'INJECTION',
    'INFUSION',
    'ORAL_SOLUTION_SUSPENSION',
    'OTHER',
]);
export const formTypeEnum = pgEnum('form_type', [
    FormType.enum.TABLET,
    FormType.enum.CAPSULE,
    FormType.enum.POWDER,
    FormType.enum.CONCENTRATE,
    FormType.enum.SOLUTION_READY,
    FormType.enum.INJECTION,
    FormType.enum.INFUSION,
    FormType.enum.ORAL_SOLUTION_SUSPENSION,
    FormType.enum.OTHER,
]);
export const DoseCalcModeActive = z.enum(['BSA', 'WEIGHT', 'ABSOLUTE', 'AUC', 'VOLUME', 'BSA30']);
export const doseCalcModeActiveEnum = pgEnum('dose_calc_mode_active', [
    DoseCalcModeActive.enum.BSA,
    DoseCalcModeActive.enum.WEIGHT,
    DoseCalcModeActive.enum.ABSOLUTE,
    DoseCalcModeActive.enum.AUC,
    DoseCalcModeActive.enum.VOLUME,
    DoseCalcModeActive.enum.BSA30,
]);
export const PresentationType = z.enum([
    'SINGLE_VIAL',
    'MULTI_VIAL_PACK',
    'PREFILLED_SYRINGE',
    'BAG',
    'CARTRIDGE',
    'OTHER',
]);
export const presentationTypeEnum = pgEnum('presentation_type', [
    PresentationType.enum.SINGLE_VIAL,
    PresentationType.enum.MULTI_VIAL_PACK,
    PresentationType.enum.PREFILLED_SYRINGE,
    PresentationType.enum.BAG,
    PresentationType.enum.CARTRIDGE,
    PresentationType.enum.OTHER,
]);
export const PreparationType = z.enum(['GRAVIMETRIC', 'PARTLY_VOLUMETRIC', 'VOLUMETRIC']);
export const preparationTypeEnum = pgEnum('preparation_type', [
    PreparationType.enum.GRAVIMETRIC,
    PreparationType.enum.PARTLY_VOLUMETRIC,
    PreparationType.enum.VOLUMETRIC,
]);
// patient_gfr and the prescription's dose basis both use these, so they live outside patients.ts (circular import)
export const GfrMethod = z.enum(['cockcroft_gault', 'jelliffe', 'urinary_24h', 'manual_entry']);
export const gfrMethodEnum = pgEnum('gfr_method', [
    GfrMethod.enum.cockcroft_gault,
    GfrMethod.enum.jelliffe,
    GfrMethod.enum.urinary_24h,
    GfrMethod.enum.manual_entry,
]);
export const SerumUnit = z.enum(['ml_dl', 'umol_l']);
export const serumUnitEnum = pgEnum('serum_unit', [SerumUnit.enum.ml_dl, SerumUnit.enum.umol_l]);
// Reports filters (CY-353): how the prescription arrived, what the production drew from,
// whether that production left a rest vial, and the QA outcome.
export const PrescriptionSource = z.enum(['cypro', 'hospital_system']);
export const prescriptionSourceEnum = pgEnum('prescription_source', [
    PrescriptionSource.enum.cypro,
    PrescriptionSource.enum.hospital_system,
]);
export const ProductionSource = z.enum(['new_pack', 'rest_vial', 'both']);
export const productionSourceEnum = pgEnum('production_source', [
    ProductionSource.enum.new_pack,
    ProductionSource.enum.rest_vial,
    ProductionSource.enum.both,
]);
export const QaResult = z.enum(['passed', 'rejected']);
export const qaResultEnum = pgEnum('qa_result', [QaResult.enum.passed, QaResult.enum.rejected]);
//# sourceMappingURL=enums.js.map